module.exports = __webpack_public_path__ + "img/io.6c807ef9.svg";